<template>
  <div>
    <List :reportType="3"></List>
  </div>
</template>
<script>
  import { wxShare } from '@/helpers/wxconfig'
  import List from './components/list.vue'
  export default {
    name: 'dailylist',
    data() {
      return {

      }
    },
    components: {
      List
    },
    methods: {

    },
    mounted() {
      wxShare('预警月报','快来看看我分享的网站:预警月报');
    }
  }
</script>
<style scoped>

</style>
